import { SERVICE_CREATE_ROUTE } from '@/core/router/route-names';
import { store } from '@/core/store';

const CreateService = () => import('@/controller/Service/create-service');

export default [
  {
    path: '/service/create',
    name: SERVICE_CREATE_ROUTE,
    component: CreateService,
    beforeEnter: (_, from, next) => {
      if (store.getters['service/serviceCompany']) {
        next();
      } else {
        next({ path: '/' });
      }
    },
  },
];
